import styled from 'styled-components';
import { maxWidthPartial, media, spacing } from '@storefront/lib-global';

export const ProductPageContent = styled.section`
  @media ${media.greaterThan('lg')} {
    display: flex;
    justify-content: center;
    ${maxWidthPartial({ withPaddingXL: true })}
    padding-block: 33px;
    position: relative;

    @media ${media.greaterThan('lg')} {
      padding-block: 33px;
    }
  }
`;
export const ProductPageContainer = styled.div`
  @media ${media.greaterThan('lg')} {
    position: relative;
  }
`;
export const Product = styled.section<{ $isZoomOverlayActive: boolean }>`
  display: ${({ $isZoomOverlayActive }) => ($isZoomOverlayActive ? 'none' : 'flex')};
  flex-direction: column;
  padding: 33px ${spacing.S};
  position: relative;

  @media ${media.greaterThan('lg')} {
    flex-direction: row;
    gap: 33px;
    justify-content: center;
    padding: unset;
    width: 100%;

    > * {
      flex: 1;
    }
  }
`;
export const MobileProductNameContainer = styled.div`
  margin: 38px ${spacing.S} 0;
`;
export const DesktopProductNameContainer = styled.div`
  display: none;

  @media ${media.greaterThan('lg')} {
    display: block;
  }
`;
export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.greaterThan('lg')} {
    max-width: 522px;
    overflow: auto;
  }
`;
